export const menuId = Object.freeze({
  clientPortal: 'clientPortal',
  home: 'home',
  features: 'features',
  accManagement: 'accManagement',
  liveAcc: 'liveAcc',
  openAdditAcc: 'openAdditAcc',
  homeDemo: 'homeDemo',
  register: 'register',
  funds: 'funds',
  depositFund: 'depositFund',
  withdrawFunds: 'withdrawFunds',
  transferBetweenAccs: 'transferBetweenAccs',
  payDetails: 'payDetails',
  transactionHis: 'transactionHis',
  download: 'download',
  profile: 'profile',
  myProfile: 'myProfile',
  cpPassword: 'cpPassword',
  securityManagement: 'securityManagement',
  tradingTools: 'tradingTools',
  marketBuzz: 'marketBuzz',
  econCalendar: 'econCalendar',
  featFx: 'featFx',
  fxIdeas: 'fxIdeas',
  asCentre: 'asCentre',
  vtrade: 'vtrade',
  vtradeProvider: 'vtradeProvider',
  vtradeFollower: 'vtradeFollower',
  vtradeLogin: 'vtradeLogin',
  promotion: 'promotion',
  redepositBonus: 'redepositBonus',
  welcomeBonus: 'welcomeBonus',
  referAFriend: 'referAFriend',
  referAFriendThailand: 'referAFriendThailand',
  depositBonus: 'depositBonus',
  noDepositBonus: 'noDepositBonus',
  dailyNewsletter: 'dailyNewsletter',
  lossRecover: 'lossRecover',
  tradingContest: 'tradingContest',
  clubBleu: 'clubBleu',
  contactUs: 'contactUs',
  support: 'support',
  offlineRewards: 'offlineRewards',
  fundsGrowthPromotion: 'fundsGrowthPromotion',
  vpsRefund: 'vpsRefund',
  propTrade: 'propTrade',
  propTradeDashboard: 'propTradeDashboard',
  propTradeCreateAccount: 'propTradeCreateAccount',
  propTradeAchievement: 'propTradeAchievement',
  luckyDraw: 'luckyDraw',
})
